import request from '@/utils/request'

export function list(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/user/add',
    method: 'post',
    type: "json",
    data
  })
}

export function edit(data) {
  return request({
    url: '/user/edit',
    method: 'post',
    type: "json",
    data
  })
}

export function setupPwd(data) {
  return request({
    url: '/user/setup-pwd',
    method: 'post',
    type: "json",
    data
  })
}

export function statusUpdate(params) {
  return request({
    url: '/user/status/update',
    method: 'post',
    params
  })
}

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function getRegisterOptions() {
  return request({
    url: '/user/register-options',
    method: 'get'
  })
}

export function sendRegisterCode(params) {
  return request({
    url: '/user/send-register-code',
    method: 'post',
    params
  })
}

export function register(data) {
  return request({
    url: '/user/register',
    method: 'post',
    type: "json",
    params: { code: data.code },
    data
  })
}

/**
 * 自述来源（How did you hear about us）：注册页跳过的账号（尤其 Shopify 授权自动建号）
 * 在 dashboard 补答一次，落 ad_user.hear_about_us
 */
export function saveHearAboutUs(value) {
  return request({
    url: '/user/hear-about-us',
    method: 'post',
    data: { value }
  })
}

export function verify(data) {
  return request({
    url: '/user/verify',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function info(data) {
  return request({
    url: '/user/info',
    method: 'post',
    data: data,
    type: "json",
  })
}

export function filterPermission() {
  return request({
    url: '/user/filter-permission',
    method: 'get'
  })
}

export function updatePassword(data) {
  return request({
    url: '/user/update/password',
    method: 'post',
    data
  })
}

export function updateInfo(data) {
  return request({
    url: '/user/update/info',
    method: 'post',
    type: "json",
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/user/reset/password',
    method: 'post',
    type: "json",
    data
  })
}

export function forgotPwd(params) {
  return request({
    url: '/x/user/forgot-pwd',
    method: 'post',
    params
  })
}

export function doForgotPwd(params) {
  return request({
    url: '/x/user/do-forgot-pwd',
    method: 'post',
    params
  })
}

export function getCommissionRates() {
  return request({
    url: '/user/commission-rates',
    method: 'get'
  })
}

